import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import CircularProgressWithLabel from './CircularWithLabel'


export default function MemberLevels(props) {
    const level = props.points / 100;
    const owner = props.owner;

    if(owner){
        return (<>
            <CircularProgressWithLabel value={100} />
            <h6>Owner</h6>
        </>
        );
    }
    else {
        if (level > 1 && level <= 2) {
            var prog = props.points - 100
            return (<>
                <CircularProgressWithLabel value={prog} />
                <h6>Level: Regular</h6>
            </>
            );
        }
        if (level > 2 && level <= 3) {
            var prog = props.points - 200
            return (<>
                <CircularProgressWithLabel value={prog} />
                <h6>Level: Veteran</h6>
            </>
            );
        }
        if (level > 3) {
            return (<>
                <CircularProgressWithLabel value={100} />
                <h6>Level: Veteran</h6>
            </>
            );
        }
    }

    

    return (
        <>
            <CircularProgressWithLabel value={props.points} />
            <h6>Level: New member</h6>
        </>);
}
